import { render, staticRenderFns } from "./ShSlider.md?vue&type=template&id=3e575ae3"
import script from "./ShSlider.md?vue&type=script&lang=js"
export * from "./ShSlider.md?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports